import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
const POPOVER_OFFSET_TOP_WITH_LABEL = '25px';
const POPOVER_OFFSET_TOP_WITHOUT_LABEL = '3px';
const POPOVER_OFFSET_BOTTOM_WITH_HELPER = '-27px';
const POPOVER_OFFSET_BOTTOM_WITHOUT_HELPER = '-8px';
export class DatePickerComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.popoverMode = false;
        this.value = '';
        this.disabled = false;
        this.error = false;
        this.placeholder = 'MM-DD-YYYY';
        this.position = 'bottom-start';
        this.locale = 'en-US';
        this.handleTextFieldKeydown = (event) => {
            if (event.key === 'Enter') {
                this.calendar.selectedDates = this.field.value;
            }
            return true;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.calendar.selectedDates) {
            this.calendar.selectedDates = this.value;
        }
    }
    placeholderChanged(_oldValue, newValue) {
        if (newValue) {
            this.placeholder = newValue;
        }
    }
    valueChanged(_, newValue) {
        if (newValue) {
            if (this.field) {
                this.field.value = newValue;
            }
            this.emitChangeEvent();
        }
    }
    emitChangeEvent() {
        this.$emit('change', { selectedDates: this.value }, { bubbles: false });
    }
    handlePopoverChanged(event) {
        // We need to stop propagation here or the onChange for the DatePicker will trigger twice
        event.stopPropagation();
        if (this.popoverMode && event.detail.isOpen) {
            this.calendar.focusCurrentOrSelectedDate();
        }
        else {
            this.field.focus();
        }
    }
    handleCalendarChanged(event) {
        var _a;
        if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.selectedDates) {
            this.value = event.detail.selectedDates;
        }
    }
    get popoverOffset() {
        const hasTopPosition = this.position.includes('top');
        const hasBottomPosition = this.position.includes('bottom');
        if (hasTopPosition) {
            return this.inputLabel ? POPOVER_OFFSET_TOP_WITH_LABEL : POPOVER_OFFSET_TOP_WITHOUT_LABEL;
        }
        if (hasBottomPosition) {
            return this.helperText ? POPOVER_OFFSET_BOTTOM_WITH_HELPER : POPOVER_OFFSET_BOTTOM_WITHOUT_HELPER;
        }
        return undefined;
    }
}
__decorate([
    attr({ mode: 'boolean', attribute: 'popover-mode' })
], DatePickerComponent.prototype, "popoverMode", void 0);
__decorate([
    attr({ attribute: 'input-label' })
], DatePickerComponent.prototype, "inputLabel", void 0);
__decorate([
    attr({ attribute: 'helper-text' })
], DatePickerComponent.prototype, "helperText", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "value", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "disabled", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "error", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "placeholder", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "position", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "locale", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "field", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "popoverElement", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "calendar", void 0);
